export default "<h1>404 Error</h1>\n"